import defaultTransition from '../transitions/default';
import homeTransition from '../transitions/home';
import storyOverviewTransition from '../transitions/story-overview';
import eventTransition from '../transitions/events';
import filmSeriesTransition from '../transitions/film-series';

export default [homeTransition, storyOverviewTransition,defaultTransition, eventTransition, filmSeriesTransition];
